export default __webpack_public_path__ + "static/media/1.7cb1c0a6.jpg";